var _path, _path2, _path3, _path4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 22.3697V43H43V22.3697C43 21.1366 42.4313 19.9724 41.4586 19.2145L24.5 6L7.5414 19.2145C6.56873 19.9724 6 21.1366 6 22.3697Z",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 24V42.5H40V24C40 23.4477 39.5523 23 39 23H10C9.44772 23 9 23.4477 9 24Z",
    fill: "#087E38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 32V42.5H24.75V32H11Z",
    fill: "white",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 35.75V32H19.75V35.75L17.875 34.25L16 35.75Z",
    fill: "#087E38",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 14,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#087E38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnHold);
export default __webpack_public_path__ + "static/media/on_hold.4000778f91b49220e86ebc3f3d152162.svg";
export { ForwardRef as ReactComponent };